import Phaser from 'phaser';
import { WORLD } from '../world.ts';
import { backdropGlow } from './TitleScene.ts';

interface Page {
  title: string;
  lines: string[];
}

const PAGES: Page[] = [
  {
    title: 'CONTROLS',
    lines: [
      'Arrows   — steer your bey (you nudge a spinning top; it banks, it drifts)',
      'Space    — strike: a big committed lunge (overshoots if it misses)',
      'Shift    — extreme dash: ride the rail and slingshot back for a huge hit',
      'C / Ctrl — hold center: anchor in the middle, take less knockback',
      'E        — special: your bey’s signature move (needs a full meter)',
      '',
      'P / Esc  — pause      M — mute      During launch: tap Space on the meter',
    ],
  },
  {
    title: 'COMBAT & FINISHES',
    lines: [
      'Your SPIN gauge is your health — it drains over time (slower with Stamina)',
      'and on every clash. Run out and you spin-out.',
      '',
      'Win a round three ways:',
      '  • SPIN-OUT  — the opponent’s spin hits zero',
      '  • RING-OUT  — knock the opponent over the dish lip (only a real hit does',
      '                this — your own momentum just wall-rides and bounces)',
      '  • BURST     — land enough hard hits to break them apart (rare, dramatic)',
      '',
      'A match is best of 3. Win the tournament to unlock the Champion’s Gauntlet.',
    ],
  },
  {
    title: 'STRATEGY',
    lines: [
      'TYPE TRIANGLE:  Attack ▸ Stamina ▸ Defense ▸ Attack   (Balance is neutral)',
      'Hitting the type you beat deals extra spin damage.',
      '',
      'SPIN-STEAL — if your spin direction (↻/↺) is opposite your foe’s, the clash',
      'winner absorbs the loser’s rotation: a brutal extra drain. Watch the arrows.',
      '',
      'CENTER STAGE — drift to the middle and slow down to anchor there for free;',
      'great for Stamina types. Steer away to break into big attacking arcs.',
      '',
      'CHARGE your special by clashing, then unleash it. Time your launch on the',
      'sweet spot for max starting spin. Build your own bey (B) to tune all of this.',
    ],
  },
];

/** A paged How-to-Play guide, reachable from the title. */
export class HelpScene extends Phaser.Scene {
  private page = 0;
  private titleText!: Phaser.GameObjects.Text;
  private bodyText!: Phaser.GameObjects.Text;
  private pageText!: Phaser.GameObjects.Text;

  constructor() {
    super('Help');
  }

  create(): void {
    this.page = 0;
    this.cameras.main.setBackgroundColor('#05060a');
    backdropGlow(this);

    this.add
      .text(WORLD.width / 2, 50, 'HOW TO PLAY', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '42px',
        fontStyle: 'bold',
        color: '#ffffff',
        stroke: '#000',
        strokeThickness: 6,
      })
      .setOrigin(0.5);

    this.titleText = this.add
      .text(WORLD.width / 2, 120, '', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '28px',
        fontStyle: 'bold',
        color: '#ffd23b',
      })
      .setOrigin(0.5);

    this.bodyText = this.add.text(120, 180, '', {
      fontFamily: 'monospace',
      fontSize: '18px',
      color: '#cfe0ff',
      lineSpacing: 8,
    });

    this.pageText = this.add
      .text(WORLD.width / 2, WORLD.height - 70, '', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '18px',
        color: '#8aa0c8',
      })
      .setOrigin(0.5);

    this.add
      .text(WORLD.width / 2, WORLD.height - 38, '◄ ►  page      ENTER / Esc  back to title', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '20px',
        color: '#8aa0c8',
      })
      .setOrigin(0.5);

    this.input.keyboard!.on('keydown-LEFT', () => this.flip(-1));
    this.input.keyboard!.on('keydown-RIGHT', () => this.flip(1));
    this.input.keyboard!.on('keydown-ENTER', () => this.scene.start('Title'));
    this.input.keyboard!.on('keydown-ESC', () => this.scene.start('Title'));

    this.refresh();
  }

  private flip(d: number): void {
    this.page = (this.page + d + PAGES.length) % PAGES.length;
    this.refresh();
  }

  private refresh(): void {
    const p = PAGES[this.page];
    this.titleText.setText(p.title);
    this.bodyText.setText(p.lines.join('\n'));
    this.pageText.setText(`${this.page + 1} / ${PAGES.length}`);
  }
}
